import { Alert } from "@mui/material";
import { PlanningResourcesEnum } from "shared/enums/resourceMappings";
import { Button, useRedirect } from "react-admin";
import { useFormContext } from "react-hook-form";
import AddIcon from "@mui/icons-material/Add";
import { FranceGroupTypeEnum } from "shared/enums/globalEnums";

const GroupMaskErrorAlert = () => {
  const redirect = useRedirect();
  const {
    formState: { errors },
  } = useFormContext();
  const { getValues } = useFormContext();
  const { type } = getValues();

  const siteErrors = errors?.site_ids;
  if (!siteErrors || type !== FranceGroupTypeEnum.rte_edp) return null;
  return (
    <Alert
      severity="error"
      action={
        <Button
          size="small"
          label="Add Planning Masks"
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => redirect("create", PlanningResourcesEnum.PlanningMasks)}
        />
      }
    >
      All sites MUST have a planning mask to create the group.
    </Alert>
  );
};

export default GroupMaskErrorAlert;
